import React from 'react';
import { Badge, BadgeList } from './styles';

interface ValueBadgesProps {
  values: string[];
  fontSize?: number;
}

const ValueBadges: React.FC<ValueBadgesProps> = ({ values, fontSize = 13 }) => {
  if (!values || !values.length) return null;
  return (
    <BadgeList>
      {values.map(v => (
        <Badge key={v} $fontSize={fontSize}>
          {v}
        </Badge>
      ))}
    </BadgeList>
  );
};

export default ValueBadges;
